import React from 'react';

const ScrollNudger = () => {
  return (
    <div className="bg-[#ebe9dc] p-1 rounded-lg relative w-1 h-24 mx-auto">
      {/* Container bar */}
      <div className="absolute inset-0 bg-black/0 rounded-full overflow-hidden">
        {/* Sliding gradient */}
        <div 
          className="absolute w-full h-full animate-nudge"
          style={{
            background: `linear-gradient(
              to bottom,
              transparent 0%,
              rgba(59,58,54, 0.3) 10%,
              rgba(59,58,54, 0.6) 30%,
              rgba(59,58,54, 0.8) 50%,
              rgba(59,58,54, 0.6) 30%,
              rgba(59,58,54, 0.3) 10%,
              transparent 0%
            )`
          }}
        />
      </div>
      
      <style jsx>{`
        @keyframes nudge {
          0% {
            transform: translateY(-100%);
          }
          40% {
            transform: translateY(50%);
          }
          60% {
            transform: translateY(60%);
          }
          100% {
            transform: translateY(100%);
          }
        }
        
        .animate-nudge {
          animation: nudge 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ScrollNudger;